import { toast } from "react-toastify";
import i18n from "multilingual";
import { removeActiveSOAPGeneration } from "redux/actions/activeSOAPGenerationActions";
import {
  refreshPatientHistoryWindow,
  refreshRecognitionEventAndState,
  resetProgressState,
} from "redux/actions/recognizerActions";
import { setRenderTabValue, set_selected_tab } from "redux/actions/ScribeAcitons";
import { CREATE_AUDIT_EVENT } from "adapters/ehr.service";
import { constants } from "redux/constants/redux-constants";

export const handleSOAPTaskCompletion = async ({
  dispatch,
  getState,
  setRecognitionEvents,
  soapPatientId,
  soapEncounterId,
  soapNoteTitle,
  defaultClinicalNoteTitle,
  practitionerId,
  patientName,
  isSuccess = true,
}) => {
  let resolvedPatientName = patientName;
  if (!resolvedPatientName) {
    const activeGenerations =
      getState().activeSOAPGeneration?.activeGenerations || [];
    const matchedGeneration = activeGenerations.find(
      (g) => g.patientId === soapPatientId && g.encounterId === soapEncounterId
    );
    resolvedPatientName = matchedGeneration?.patientName || "";
  }

  const state = getState();
  const currentSelectedPatientId = state?.patientObj?.patientObj?.id;
  const currentSelectedEncounterId = state?.encounterObj?.encounter?.id;

  if (
    soapPatientId === currentSelectedPatientId &&
    soapEncounterId === currentSelectedEncounterId
  ) {
    refreshPatientHistoryWindow({
      setRecognitionEvents,
      dispatch,
    });
  } else {
    refreshRecognitionEventAndState({
      dispatch,
      setRecognitionEvents,
    });
  }

  const soapNoteLabel = defaultClinicalNoteTitle || soapNoteTitle;
  
  dispatch(
    setRenderTabValue({
      label: soapNoteLabel,
      selectedTabIndex: 2,  
    })
  );

 dispatch(
    set_selected_tab({
      value: 2,
      title: soapNoteLabel || "SOAP Note",
    })
  );

  try {
    await CREATE_AUDIT_EVENT({
      practitionerID: `Practitioner/${practitionerId}`,
      patientName: resolvedPatientName,
      type: { display: "Create", code: "110120" },
      reason: JSON.stringify({
        msg_code: isSuccess ? "SOAP_NOTE_GENERATED" : "DRAFT_ADDED",
      }),
    });
  } catch (error) {
    console.error("Failed to create audit event:", error);
    toast.error("Audit event could not be created.", {
      data: { ignoreNotification: true },
    });
  }

  try {
    if (isSuccess) {
      toast.success(`SOAP Note ${i18n.t(`common.GENERATED_SUCCESSFULLY`)}`, {
        data: { ignoreNotification: true },
      });
    } else {
      toast.error("SOAP note generation failed. Transcript saved as draft.", {
        data: { ignoreNotification: true },
      });
    }
  } finally {
    dispatch(
      resetProgressState({
        patientId: soapPatientId,
        encounterId: soapEncounterId,
      })
    );
    dispatch({
      type: constants.RECOGNIZER.STOP_RECORDING,
      payload: { patientId: soapPatientId, encounterId: soapEncounterId },
    });
    dispatch({
      type: constants.RECOGNIZER.RESET_RECOGNIZER_FOR_ENCOUNTER,
    });

    // dispatch({
    //   type: constants.PROGRESS_STATUS,
    //   payload: false,
    // });
    // Remove active generation last
    dispatch(
      removeActiveSOAPGeneration({
        patientId: soapPatientId,
        encounterId: soapEncounterId,
        patientName: resolvedPatientName,
      })
    );
  }
};
